import { render } from "./wokerDetail6.vue?vue&type=template&id=67a95f78&scoped=true"
import script from "./wokerDetail6.vue?vue&type=script&lang=js"
export * from "./wokerDetail6.vue?vue&type=script&lang=js"

import "./wokerDetail6.vue?vue&type=style&index=0&id=67a95f78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a95f78"]])

export default __exports__